export class AssetSummaryContentful {
    showAssetUrl!: boolean;
    summary!: string;
    logo!: string;
    slidingImgs: { src: string }[] = [];
    assetURL!: string;
    showMap = false;
    position!: { lat: number; lng: number; };
}
